import React, { Component } from 'react';
import './style.css';

export default class Loader extends Component {
  render() {
    const size = this.props.size ? this.props.size : '';
    return <div className={`loader_${size}`} />;
  }
}
